export { textColor } from './textColor';
export { underline } from './underline';
export { textHighlight } from './textHighlight';
export { textAlignment } from './textAlignment';
export { strikeThrough } from './strikeThrough';
export { fontFamily } from './fontFamily';